import { DataGrid } from '@tableau/data-grid-1-wrapper';
import { NestedProjectExplorer } from '@tableau/nested-project-explorer';
import { SelfServiceSchedulePane } from '@tableau/self-service-schedules';
import { ActivitySpinnerWidget } from '@tableau/widgets';

import { getAppStore } from '../../app/AppStore';
import { DeprecatedReactPlacePageActionsMenu } from '../../app/content/PlacePageActionsMenu';
import { RemoteAgentPresenceIcon } from '../../app/content/RemoteAgentPresenceIcon';
import { SpotlightActionList } from '../../app/content/SpotlightActionList';
import { SignInLogo } from '../../app/spaces/Login/SignInLogo';
import { SignInNoteDescription } from '../../app/spaces/Login/SignInNoteDescription';
import { MetricSparklineAndPill } from '../../metrics/components/MetricSparklineAndPill';
import { AnalyticsExtensionsSettingsForSite } from '../../settings/components/AnalyticsExtensionsSettingsForSite';
import { ReactServerSettings } from '../../settings/general-settings/components/server-settings/ReactServerSettings';
import {
  AuthenticationProviderSelector
} from '../../settings/siteAuthSettings/directives/AuthenticationProviderSelector';
import { ReactDirectiveFactory } from '../../ts/directives/reactDirectiveFactory';
import { FilteringListBox } from './components/FilteringListBox';
import { NaturalLanguage } from './components/NaturalLanguage';
import { SiteMembershipFilters } from './components/SiteMembershipFilters';
import { SiteRolePickerMenu } from './components/SiteRolePickerMenu';

// TODO: Figure out how to replace this dependency in this file
/**
 * This file contains all the components that use "angular directive wrapping".
 *
 * See reactDirectiveFactory.ts for a description of how these wrappers work.
 */

ReactDirectiveFactory.create({ name: 'tbActivitySpinner', component: ActivitySpinnerWidget });
ReactDirectiveFactory.create({ name: 'tbNaturalLanguage', component: NaturalLanguage });
ReactDirectiveFactory.create({ name: 'tbNestedProjectExplorer', component: NestedProjectExplorer });
ReactDirectiveFactory.create({ name: 'tbSignInLogo', component: SignInLogo });
ReactDirectiveFactory.create({ name: 'tbPlacePageActionsMenu', component: DeprecatedReactPlacePageActionsMenu });
ReactDirectiveFactory.create({ name: 'tbSelfServiceSchedulePane', component: SelfServiceSchedulePane });
ReactDirectiveFactory.create({ name: 'tbReactFilteringListBox', component: FilteringListBox });
ReactDirectiveFactory.create({ name: 'tbMetricSparklineAndPill', component: MetricSparklineAndPill});

ReactDirectiveFactory.create({
  name: 'tbReactDataGrid',
  component: DataGrid,
  // TODO: replace these watched props with Flux stores. Tracked by TFS: 495959
  watch_useIsDiscouraged: [
    'props.selectionData', // TODO: When we upgrade to Data Grid 3, this must be changed to `props.selectionModel` (TFS 769654)
    'props.sortKey',
    'props.sortAscending',
    'props.rowStore',
    'props.cols',
    'props.requestedFocusedRowIndex', // TODO: When we upgrade to Data Grid 2, remove this prop from the watch list (TFS 769643)
    'props.leftMargin'
  ]
});
ReactDirectiveFactory.create({ name: 'tbRemoteAgentPresenceIcon', component: RemoteAgentPresenceIcon });
ReactDirectiveFactory.create({ name: 'tbSiteRolePickerMenu', component: SiteRolePickerMenu, watch_useIsDiscouraged: ['props.selectedRole', 'props.isDisabled'] });
ReactDirectiveFactory.create({ name: 'tbSpotlightActionList', component: SpotlightActionList });
ReactDirectiveFactory.create({ name: 'tbSiteMembershipFilters', component: SiteMembershipFilters });
ReactDirectiveFactory.create({ name: 'tbAnalyticsExtensionsSettings', component: AnalyticsExtensionsSettingsForSite, store: getAppStore() });
ReactDirectiveFactory.create({ name: 'tbReactServerSettings', component: ReactServerSettings, store: getAppStore() });
ReactDirectiveFactory.create({ name: 'tbSignInNoteDescription', component: SignInNoteDescription});
ReactDirectiveFactory.create({ name: 'tbAuthenticationProviderSelector', component: AuthenticationProviderSelector});
